import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from 'ng2-translate';
import { Subscription } from 'rxjs';
import { CardsDisplayMode } from '../../enums/cards-display-mode.enum';
import { CardsFilterPosition } from '../../enums/cards-filter-position.enum';
import { CardsOrientation } from '../../enums/cards-orientation.enum';
import { CardsSize } from '../../enums/cards-size.enum';
import { CardCategory } from '../../models/card-category';
import { CardSearchField } from '../../models/card-search-field';


@Component({
    selector: 'cards-list',
    templateUrl: './cards-list.component.html',
    styleUrls: ['./cards-list.component.scss']
})
export class CardsListComponent implements OnInit, OnDestroy {
    public tagNum: number;
    public radioButtonName: string;
    public categInit: boolean = false;
    public hasAnElementVisible: boolean = false;

    public filterWord: string;
    public filterItemQueryString = new FormControl();
    private _inputChangeSubscription: Subscription;
    @ViewChild('tagAll') public tagAll: any;

    private _categories: CardCategory[] = [];

    @Input() public categorized: boolean = true;
    @Input() public cardsMode: CardsDisplayMode = CardsDisplayMode.CARDS;
    @Input() public cardsSize: CardsSize = CardsSize.MEDIUM;
    @Input() public hasFilter: boolean = true;
    @Input() public hasSearch: boolean = true;

    private _searchOn: CardSearchField[] = [];
    public searchOnPlaceHolder: string = '';

    @Input() public cardsOrientation: CardsOrientation = CardsOrientation.WRAPPED;
    @Input() public cardsFilterPosition: CardsFilterPosition = CardsFilterPosition.TOP;

    @Input() public itemClickAction: Function;
    @Input() public itemDblClickAction: Function;

    @Input() public currentItemId: number;
    @Input() public showSubtitle: boolean = true;

    private filterPositionLeft: CardsFilterPosition = CardsFilterPosition.LEFT;
    private filterPositionTop: CardsFilterPosition = CardsFilterPosition.TOP;

    @Input() public noResultTitle: string = '';
    @Input() public noResultSubTitle: string = '';

    @Input() public loadingTitle: string = '';
    @Input() public loadingSubTitle: string = '';

    constructor(private _translateService: TranslateService) {
        this.tagNum = Math.round(Math.random() * 100000);
        this.radioButtonName = 'filter-radio' + this.tagNum;
    }

    @Input()
    public get searchOn(): CardSearchField[] {
        return this._searchOn;
    }
    public set searchOn(value: CardSearchField[]) {
        this._searchOn = value;

        this.searchOnPlaceHolder = this._translateService.instant('card-list.search.place-holder') + ' ';

        let labels: string[] = [];

        for (let field of this._searchOn) {
            labels.push(field.label);
        }

        let lastLabel: string = '';

        if (labels.length > 1) {
            lastLabel += ' ' + this._translateService.instant('card-list.search.or') + ' ' + labels.pop();
        }

        this.searchOnPlaceHolder += labels.join(', ') + lastLabel;
    }

    @Input()
    public get categories(): CardCategory[] {
        return this._categories;
    }
    public set categories(value: CardCategory[]) {
        if (value.length > 0) {
            this.categInit = true;
        }

        if (!this.categorized) {
            let uniqueCateg: CardCategory = new CardCategory({ color: 'neutral' });

            for (let categ of value) {
                for (let item of categ.items) {
                    this.hasAnElementVisible = true;
                    uniqueCateg.items.push(item);
                }
            }

            value = [uniqueCateg];
        }
        this._categories = value;
    }

    public ngOnInit() {
        this.subscribeInputChange();
    }

    public ngOnDestroy() {
        if (this._inputChangeSubscription != undefined) {
            this._inputChangeSubscription.unsubscribe();
        }
    }

    private subscribeInputChange() {
        this._inputChangeSubscription = this.filterItemQueryString.valueChanges
            .subscribe(term => {
                this.resetCategFilter();
                this.hasAnElementVisible = false;

                for (let c of this.categories) {
                    c.setFilter(term, this.searchOn);
                    this.hasAnElementVisible = this.hasAnElementVisible || c.active;
                }
            });
    }

    public resetCategFilter() {
        this.tagAll.nativeElement.checked = true;
    }

    public resetSearchFilter() {
        this.filterWord = '';
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/containers/cards-list/cards-list.component.ts